import React, { memo, useMemo } from 'react';
import { GroupedArticleSection } from './GroupedArticleIndexPageResultsMainArea';
import CTABarSmall, { CTABarSmallBlokProps } from '../CTABarSmall/CTABarSmall';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import { AlgoliaModifiedQueryData } from '../../interfaces/AlgoliaModifiedQueryData.interface';
import Heading, { HeadingTypes } from '../Heading/Heading';
import ArticleIndexPageResultCard from '../ArticleIndexPage/ArticleIndexPageResultCard';

export interface GroupedArticleIndexPageResultsSectionProps {
  section: GroupedArticleSection;
  ctaBar: CTABarSmallBlokProps[];
  index: number;
}

const GroupedArticleIndexPageResultsSection: React.FC<
  GroupedArticleIndexPageResultsSectionProps
> = ({ section, ctaBar, index }) => {
  const topRowArticles = useMemo<AlgoliaModifiedQueryData[]>(() => {
    return section.articles.slice(0, section.articles.length === 3 ? 3 : 2);
  }, [section.articles]);

  const bottomRowArticles = useMemo<AlgoliaModifiedQueryData[]>(() => {
    return section.articles.slice(2, section.articles.length - 1);
  }, [section.articles]);

  return (
    <section
      className="py-24 bg-surface/background"
      id={section.title.toLowerCase().replaceAll(' ', '-')}
    >
      <Container>
        <Grid>
          <Col span={{ xl: 9 }} start={{ xl: 4 }}>
            <div className="space-y-16">
              <Heading text={section.title} headingType={HeadingTypes.h2} />
              <Grid>
                {topRowArticles.map((article: AlgoliaModifiedQueryData) => (
                  <Col
                    key={article.id}
                    span={{ md: topRowArticles.length === 3 ? 4 : 6 }}
                  >
                    <ArticleIndexPageResultCard article={article} />
                  </Col>
                ))}
              </Grid>
              {index === 0 && (
                <>
                  {ctaBar.map((bar: CTABarSmallBlokProps) => (
                    <CTABarSmall key={bar._uid} blok={bar} />
                  ))}
                </>
              )}
              {!!bottomRowArticles.length && (
                <Grid>
                  {bottomRowArticles.map(
                    (article: AlgoliaModifiedQueryData) => (
                      <Col
                        key={article.id}
                        span={{ md: bottomRowArticles.length === 2 ? 6 : 4 }}
                      >
                        <ArticleIndexPageResultCard article={article} />
                      </Col>
                    )
                  )}
                </Grid>
              )}
            </div>
          </Col>
        </Grid>
      </Container>
    </section>
  );
};

export default memo(GroupedArticleIndexPageResultsSection);
